import { useLogin } from '@refinedev/core';
import { Form, Input, Button, Card, Typography, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

interface LoginForm {
  username: string;
  password: string;
}

export const Login = () => {
  const { mutate: login, isLoading } = useLogin<LoginForm>();
  const [form] = Form.useForm();

  const onFinish = (values: LoginForm) => {
    login(values, {
      onError: (error) => {
        message.error(error.message || "Login yoki parol noto'g'ri");
      },
    });
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #1a1a2e 100%)',
        padding: 16,
      }}
    >
      <Card
        style={{
          width: '100%',
          maxWidth: 420,
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
          borderRadius: 20,
          border: 'none',
        }}
        styles={{ body: { padding: '40px 32px' } }}
      >
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <div
            style={{
              width: 90,
              height: 90,
              margin: '0 auto 20px',
              borderRadius: 20,
              background: 'linear-gradient(135deg, #1ABC9C 0%, #16A085 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 8px 24px rgba(26, 188, 156, 0.35)',
            }}
          >
            <img
              src="/safargo.png"
              alt="Safaro"
              style={{ width: 70, height: 70, borderRadius: 14 }}
            />
          </div>
          <Title level={2} style={{ margin: 0, color: '#1a1a2e', fontWeight: 700 }}>
            Safaro
          </Title>
          <Text style={{ color: '#8c8c8c', fontSize: 15 }}>Admin Panel</Text>
        </div>

        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          autoComplete="off"
          size="large"
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: 'Login kiriting' }]}
          >
            <Input
              prefix={<UserOutlined style={{ color: '#bfbfbf' }} />}
              placeholder="Login"
              autoComplete="username"
              style={{ height: 50, borderRadius: 10 }}
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Parol kiriting' }]}
          >
            <Input.Password
              prefix={<LockOutlined style={{ color: '#bfbfbf' }} />}
              placeholder="Parol"
              autoComplete="current-password"
              style={{ height: 50, borderRadius: 10 }}
            />
          </Form.Item>

          <Form.Item style={{ marginBottom: 0, marginTop: 8 }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={isLoading}
              block
              style={{
                height: 52,
                fontSize: 16,
                fontWeight: 600,
                borderRadius: 10,
              }}
            >
              Kirish
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};
